import { memo } from 'react';
import { Handle, Position, type NodeProps } from 'reactflow';
import { Radio } from 'lucide-react';

const WebhookNode = ({ data, selected }: NodeProps) => {
    return (
        <div className={`
            px-4 py-2 shadow-md rounded-lg bg-white border-2 
            ${selected ? 'border-blue-500 ring-2 ring-blue-200' : 'border-gray-200'}
            hover:border-blue-400 transition-all min-w-[180px]
        `}>
            <div className="flex items-center">
                <div className="rounded-lg bg-yellow-100 p-2 mr-3">
                    <Radio className="w-5 h-5 text-yellow-600" />
                </div>
                <div>
                    <div className="text-sm font-bold text-gray-900">
                        {data.label || 'Webhook Listener'}
                    </div>
                    <div className="text-[10px] text-gray-500">
                        {data.hasSchema ? 'Schema Detected' : 'Waiting for Event...'}
                    </div>
                </div>
            </div>

            <Handle
                type="source"
                position={Position.Right}
                className="w-3 h-3 bg-blue-500 border-2 border-white"
            />
        </div>
    );
};

export default memo(WebhookNode);
